import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <motion.header initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.5
  }} className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${isScrolled ? 'bg-navy shadow-lg' : 'bg-transparent'}`} data-id="element-96">
      <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between" data-id="element-97">
        <div data-id="element-98"></div>

        <a href="#agenda" className="bg-gold hover:bg-yellow-500 text-navy font-semibold px-6 py-2.5 rounded transition-colors duration-200 text-sm sm:text-base" data-id="element-99">
          Agendar diagnóstico
        </a>
      </div>
    </motion.header>;
}